<lds-card *appLoad="let data of taskOverview$; trackingName: 'task-list'" padding="md">
  <div class="task-insights">

    <!-- task / overdue -->
    <lds-tooltip message="{{ data.overdue || 0 | plural: 'task' }} overdue">
      <div class="task"
           [routerLink]="['/Tasks']"
           [queryParams]="{ tracking: 'overdue'}">

        <div class="task__status task__status--red">
          <div class="task__status-value">
            {{ data.overdue || "0" }}
          </div>
          <div class="task__status-icon">
            <lds-icon name="tasks"></lds-icon>
          </div>
        </div>
        <div class="task__label">
          overdue
        </div>
      </div>
    </lds-tooltip>

    <!-- task / due now -->
    <lds-tooltip message="{{ data.dueNow || '0' | plural: 'task' }} due now">
      <div class="task"
           [routerLink]="['/Tasks']"
           [queryParams]="{ tracking: 'now'}">
        <div class="task__status task__status--orange">
          <div class="task__status-value">
            {{ data.dueNow || "0" }}
          </div>
          <div class="task__status-icon">
            <lds-icon name="tasks"></lds-icon>
          </div>
        </div>
        <div class="task__label">
          due now
        </div>
      </div>
    </lds-tooltip>

    <!-- task / upcoming -->
    <lds-tooltip message="{{ data.upcoming || '0' | plural: 'task' }} upcoming">
      <div class="task"
           [routerLink]="['/Tasks']"
           [queryParams]="{ tracking: 'upcoming'}">
        <div class="task__status task__status--green">
          <div class="task__status-value">
            {{ data.upcoming || "0" }}
          </div>
          <div class="task__status-icon">
            <lds-icon name="tasks"></lds-icon>
          </div>
        </div>
        <div class="task__label">
          upcoming
        </div>
      </div>
    </lds-tooltip>

  </div>
</lds-card>
